var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAndercoreA = function SvgAndercoreA(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D30B0B",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.788 4.688c-.012.02-.672 1.294-1.475 2.84a549 549 0 0 1-1.719 3.305l-.26.5h1.898l1.365-2.685 1.36-2.682.066.11c.036.06.313.598.619 1.196l.55 1.09H7.713l-.379.733-.375.733h2.978l.375.753.379.752h1.94l-.368-.7c-.203-.386-.985-1.884-1.743-3.328L9.143 4.68l-1.17-.012c-.643-.004-1.177.004-1.185.02"
  })));
};
export default SvgAndercoreA;